const ICONS = {
  1: 'pp_45',
  2: 'pp_50',
  3: 'pp_59',
  4: 'pp_57',
  5: 'pp_49',
  6: 'pp_55',
  7: 'pp_47',
  8: 'pp_01',
  9: 'pp_75',
  10: 'pp_73',
  11: 'pc_32',
  12: 'pc_16',
  13: 'pc_45',
  14: 'pp_66',
  15: 'pp_07',
  16: 'pp_14',
  17: 'pp_14',
  18: 'pp_13',
  19: 'pp_02',
  20: 'pp_20',
  21: 'pp_26',
  22: 'pp_13',
  23: 'pc_45',
  24: 'pc_45',
  25: 'pc_33',
  26: 'pc_15',
  27: 'pc_21',
  28: 'pc_20',
  29: 'pc_45',
  30: 'pc_20',
  31: 'pc_45',
  32: 'pc_36',
  33: 'pc_11',
  34: 'pc_36',
  35: 'pc_10',
  36: 'pc_36',
  37: 'pc_36',
  38: 'pc_36',
  39: 'pc_41',
  40: 'pp_17',
  41: 'pp_18',
  42: 'ps_26',
  43: 'pc_017',
  44: 'pc_017',
  45: 'pc_12',
  46: 'pc_017',
  47: 'pp_24',
  48: 'pa_01',
  49: 'pp_65',
  50: 'pp_66',
  51: 'pc_28',
  52: 'pp_76',
  53: 'pc_26',
  54: 'pp_65',
  55: 'pp_13',
  56: 'pc_01',
  57: 'pc_42',
  58: 'pc_39',
  59: 'pc_47',
  60: 'pp_66',
  61: 'pc_17',
  62: 'pc_31',
  63: 'pc_29',
  64: 'pa_11',
  65: 'pc_25',
  66: 'pc_07',
  67: 'pc_00',
  68: 'ps_11',
  69: 'pp_72',
  70: 'pc_70',
  71: 'pp_48-alt',
  72: 'pp_02_bm',
  73: 'pp_14_bm',
  74: 'pp_13_bm'
}

export function getSubcategoryIcon (data) {
  const name = ICONS[data] || 'pp_00'
  return {
    icon: `poi/${name}.svg`,
    iconMap: name
  }
}
